import { Component, OnInit } from '@angular/core';
import {AchatService} from '../../../../../../services/achat/achat.service';

@Component({
  selector: 'app-annule-fac-f',
  templateUrl: './annule-fac-f.component.html',
  styleUrls: ['./annule-fac-f.component.scss']
})
export class AnnuleFacFComponent implements OnInit {

    constructor(private dataService: AchatService) {}

    ngOnInit(): void {
        console.log('TousCmdComponent initialized');
        this.dataService.filterFactureFournisseurByStatus('Annulé');
    }

}
